module.exports = __webpack_public_path__ + "static/media/phone_usecase_cropped2.093915ee.png";